import { Clock } from "lucide-react";

interface AuditEntry {
  id?: number;
  action?: string;
  fromStatus?: string | null;
  toStatus?: string | null;
  performedBy?: string | number | null;
  reason?: string | null;
  createdAt?: string | null;
}

interface SupplierInvoiceAuditProps {
  auditLog?: AuditEntry[] | null;
}

function formatDateTime(d: string) {
  return new Date(d).toLocaleString("es-ES");
}

export function SupplierInvoiceAudit({ auditLog }: SupplierInvoiceAuditProps) {
  if (!auditLog || auditLog.length === 0) {
    return (
      <div className="text-center py-8 text-sm text-muted-foreground">
        <Clock className="h-8 w-8 mx-auto mb-2 opacity-30" />
        No hay historial de cambios disponible.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <ol className="relative border-l border-muted ml-3 space-y-4">
        {auditLog.map((entry, i) => (
          <li key={entry.id ?? i} className="ml-4">
            <span className="absolute -left-1.5 mt-1.5 h-3 w-3 rounded-full border border-background bg-muted-foreground/40" />
            <div className="space-y-1">
              <p className="text-sm font-medium">{entry.action ?? "Cambio de estado"}</p>
              {entry.fromStatus && entry.toStatus && (
                <p className="text-xs text-muted-foreground">
                  {entry.fromStatus} → {entry.toStatus}
                </p>
              )}
              {entry.reason && (
                <p className="text-xs text-muted-foreground italic">"{entry.reason}"</p>
              )}
              {entry.createdAt && (
                <p className="text-xs text-muted-foreground">{formatDateTime(entry.createdAt)}</p>
              )}
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
